import { render } from "./MerchantProfilesList.vue?vue&type=template&id=56a4ec07"
import script from "./MerchantProfilesList.vue?vue&type=script&lang=js"
export * from "./MerchantProfilesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__